import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { SeguimientoComponent } from './pages/seguimiento/seguimiento.component';
import { ContactoComponent } from './pages/contacto/contacto.component';
import { Pagina3Component } from './pages/pagina3/pagina3.component';
import { DocumentosAuditoriaComponent } from './pages/documentos-auditoria/documentos-auditoria.component';
import { DocumentosAuditoriaGuard } from './guards/documentos-auditoria.guard';
import { PagenotfoundComponent } from './pages/pagenotfound/pagenotfound.component';


const routes: Routes = [
  { path: 'inicio', loadChildren: () => import('./pages/inicio/inicio.module').then(m => m.InicioModule) },
  { path: 'perfil', loadChildren: () => import('./pages/perfil/perfil.module').then(m => m.PerfilModule) },
  {path: 'cargar-documentos', component: SeguimientoComponent},
  {path: 'contacto', component: ContactoComponent},
  {path: 'documentos-auditoria',
  canActivate: [DocumentosAuditoriaGuard],
   component: DocumentosAuditoriaComponent},
  { path: 'registro', loadChildren: () => import('./pages/registro/registro.module').then(m => m.RegistroModule) },
  {path: 'pagenotfound', component: PagenotfoundComponent},
  {path: '**', component: SeguimientoComponent},
];

@NgModule({
  imports: [
    RouterModule.forRoot( routes, {useHash: true} )
  ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
